(function () {
  "use strict";

  var STORAGE_KEY = "ttp_google_ads_click";
  var SYNC_KEY = "ttp_google_ads_click_synced";
  var MAX_AGE_DAYS = 90;
  var SYNC_INTERVAL_MS = 30 * 60 * 1000;
  var CLICK_KEYS = ["gclid", "gbraid", "wbraid"];
  var UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
  // Marketingtoestemming uit Shopify's privacybanner (Customer Privacy API). O-Tools stuurt dit als
  // consent.ad_user_data mee naar Google Ads: granted -> GRANTED, denied of none -> DENIED.
  var CONSENT_ATTRIBUTE = "google_consent_marketing__";

  // Opslag op het apparaat (localStorage en cookie) alleen na marketingtoestemming. Zonder toestemming blijft
  // de klik-ID in het geheugen van deze pagina en gaat hij alleen als cart-attribuut naar Shopify.
  var urlCapture = null;
  var memoryPayload = null;
  var memorySync = {};
  var storedOnDevice = false;
  var originalFetch = null;

  function nowIso() {
    return new Date().toISOString();
  }

  function readParams() {
    try {
      return new URLSearchParams(window.location.search || "");
    } catch (error) {
      return null;
    }
  }

  function getParam(params, key) {
    if (!params) return "";
    return (params.get(key) || params.get(key.toUpperCase()) || "").trim();
  }

  function firstClickId(params) {
    for (var i = 0; i < CLICK_KEYS.length; i += 1) {
      var key = CLICK_KEYS[i];
      var value = getParam(params, key);
      if (value) {
        return { type: key, value: value };
      }
    }
    return null;
  }

  function setCookie(name, value) {
    var maxAge = MAX_AGE_DAYS * 24 * 60 * 60;
    document.cookie =
      name + "=" + encodeURIComponent(value) + "; Path=/; Max-Age=" + maxAge + "; SameSite=Lax";
  }

  function deleteCookie(name) {
    document.cookie = name + "=; Path=/; Max-Age=0; SameSite=Lax";
  }

  function getCookie(name) {
    var parts = document.cookie ? document.cookie.split("; ") : [];
    for (var i = 0; i < parts.length; i += 1) {
      var pair = parts[i].split("=");
      if (pair.shift() === name) {
        return decodeURIComponent(pair.join("=") || "");
      }
    }
    return "";
  }

  function storageAllowed() {
    return readConsent() === "granted";
  }

  function savePayload(payload) {
    memoryPayload = payload;
    if (!storageAllowed()) return;
    var text = JSON.stringify(payload);
    try {
      window.localStorage.setItem(STORAGE_KEY, text);
    } catch (error) {}
    setCookie(STORAGE_KEY, text);
  }

  function loadStoredPayload() {
    if (!storageAllowed()) return null;
    var text = "";
    try {
      text = window.localStorage.getItem(STORAGE_KEY) || "";
    } catch (error) {}
    if (!text) text = getCookie(STORAGE_KEY);
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (error) {
      return null;
    }
  }

  function clearStoredPayload() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
      window.localStorage.removeItem(SYNC_KEY);
    } catch (error) {}
    deleteCookie(STORAGE_KEY);
  }

  function isExpired(payload) {
    if (!payload || !payload.first_seen_at) return true;
    var firstSeen = Date.parse(payload.first_seen_at);
    if (!firstSeen) return true;
    return Date.now() - firstSeen > MAX_AGE_DAYS * 24 * 60 * 60 * 1000;
  }

  function readUrlCapture() {
    var params = readParams();
    var click = firstClickId(params);
    var hasUtm = false;
    var utms = {};

    for (var i = 0; i < UTM_KEYS.length; i += 1) {
      var key = UTM_KEYS[i];
      var value = getParam(params, key);
      if (value) {
        utms[key] = value;
        hasUtm = true;
      }
    }

    if (!click && !hasUtm) return null;
    return { click: click, utms: utms, url: window.location.href, at: nowIso() };
  }

  function mergePayload(capture, existing) {
    var click = capture.click;
    var utms = capture.utms;
    var payload = {
      click_id: click ? click.value : existing && existing.click_id ? existing.click_id : "",
      click_type: click ? click.type : existing && existing.click_type ? existing.click_type : "",
      landing_page: capture.url,
      first_seen_at: existing && existing.first_seen_at ? existing.first_seen_at : capture.at,
      last_seen_at: capture.at,
      utm_source: utms.utm_source || "",
      utm_medium: utms.utm_medium || "",
      utm_campaign: utms.utm_campaign || "",
      utm_term: utms.utm_term || "",
      utm_content: utms.utm_content || ""
    };

    if (existing && existing.click_id && !click) {
      payload.landing_page = existing.landing_page || payload.landing_page;
    }

    return payload;
  }

  function ownFetch(url, options) {
    // Eigen cart-aanroepen buiten de wrapper om; anders start elke /cart/update.js weer een nieuwe sync.
    return (originalFetch || window.fetch).call(window, url, options);
  }

  function payloadFromCart() {
    return ownFetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        var attributes = (cart && cart.attributes) || {};
        var payload = {
          click_id: attributes.google_click_id__ || "",
          click_type: attributes.google_click_type__ || "",
          landing_page: attributes.google_landing_page__ || "",
          first_seen_at: attributes.google_first_seen_at__ || "",
          last_seen_at: attributes.google_last_seen_at__ || "",
          utm_source: attributes.google_utm_source__ || "",
          utm_medium: attributes.google_utm_medium__ || "",
          utm_campaign: attributes.google_utm_campaign__ || "",
          utm_term: attributes.google_utm_term__ || "",
          utm_content: attributes.google_utm_content__ || ""
        };
        return payload.click_id || payload.utm_source || payload.utm_campaign ? payload : null;
      })
      .catch(function () {
        return null;
      });
  }

  function readConsent() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.marketingAllowed !== "function") return "";
      if (privacy.marketingAllowed()) return "granted";
      var current = typeof privacy.currentVisitorConsent === "function" ? privacy.currentVisitorConsent() || {} : {};
      if (current.marketing === "no") return "denied";
      return "none";
    } catch (error) {
      return "";
    }
  }

  function ensurePrivacyApi(callback) {
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      callback();
    }
    try {
      if (window.Shopify && window.Shopify.customerPrivacy) return finish();
      if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], finish);
        window.setTimeout(finish, 3000);
        return;
      }
    } catch (error) {}
    finish();
  }

  function applyConsent(force) {
    if (!storageAllowed()) {
      if (readConsent() === "denied") clearStoredPayload();
      storedOnDevice = false;
      return syncToCart(force);
    }
    if (!storedOnDevice) {
      storedOnDevice = true;
      var existing = loadStoredPayload();
      if (existing && isExpired(existing)) {
        clearStoredPayload();
        existing = null;
      }
      if (urlCapture) savePayload(mergePayload(urlCapture, existing));
      else if (memoryPayload && !isExpired(memoryPayload)) savePayload(memoryPayload);
      else if (existing) memoryPayload = existing;
    }
    return syncToCart(force);
  }

  function onConsentCollected() {
    // Keuze op een latere pagina: de klik-ID van de landingspagina staat dan alleen nog in de cart.
    if (urlCapture || memoryPayload) return applyConsent(true);
    return payloadFromCart().then(function (payload) {
      if (payload && !memoryPayload) memoryPayload = payload;
      return applyConsent(true);
    });
  }

  function buildAttributes(payload) {
    var attributes = {
      google_click_id__: payload.click_id || "",
      google_click_type__: payload.click_type || "",
      google_landing_page__: payload.landing_page || "",
      google_first_seen_at__: payload.first_seen_at || "",
      google_last_seen_at__: payload.last_seen_at || "",
      google_utm_source__: payload.utm_source || "",
      google_utm_medium__: payload.utm_medium || "",
      google_utm_campaign__: payload.utm_campaign || "",
      google_utm_term__: payload.utm_term || "",
      google_utm_content__: payload.utm_content || ""
    };
    var consent = readConsent();
    if (consent) attributes[CONSENT_ATTRIBUTE] = consent;
    return attributes;
  }

  function lastSyncInfo() {
    if (!storageAllowed()) return memorySync;
    try {
      return JSON.parse(window.localStorage.getItem(SYNC_KEY) || "{}");
    } catch (error) {
      return {};
    }
  }

  function markSynced(signature) {
    memorySync = { signature: signature, at: Date.now() };
    if (!storageAllowed()) return;
    try {
      window.localStorage.setItem(SYNC_KEY, JSON.stringify(memorySync));
    } catch (error) {}
  }

  function shouldSync(payload, force) {
    if (!payload || isExpired(payload)) return false;
    if (!payload.click_id && !payload.utm_source && !payload.utm_campaign) return false;
    if (force) return true;
    var signature = JSON.stringify(buildAttributes(payload));
    var last = lastSyncInfo();
    if (last.signature !== signature) return true;
    return Date.now() - Number(last.at || 0) > SYNC_INTERVAL_MS;
  }

  function syncToCart(force) {
    var payload = memoryPayload;
    if (!shouldSync(payload, force)) return Promise.resolve(false);
    var attributes = buildAttributes(payload);
    var signature = JSON.stringify(attributes);

    return ownFetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (response) {
        if (response.ok) markSynced(signature);
        return response.ok;
      })
      .catch(function () {
        return false;
      });
  }

  function wrapCartFetch() {
    if (!window.fetch || window.__ttpAdsFetchWrapped) return;
    originalFetch = window.fetch;
    window.__ttpAdsFetchWrapped = true;
    window.fetch = function () {
      var url = arguments[0] && arguments[0].url ? arguments[0].url : String(arguments[0] || "");
      var result = originalFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)\.js/.test(url)) {
        result.then(function () {
          window.setTimeout(function () {
            syncToCart(true);
          }, 150);
        });
      }
      return result;
    };
  }

  function syncBeforeCheckout(event) {
    var target = event.target;
    if (!target) return;
    var checkoutLink = target.closest ? target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]') : null;
    if (!checkoutLink) return;
    syncToCart(true);
  }

  urlCapture = readUrlCapture();
  if (urlCapture) memoryPayload = mergePayload(urlCapture, null);

  wrapCartFetch();
  ensurePrivacyApi(function () {
    applyConsent(false);
  });
  document.addEventListener("click", syncBeforeCheckout, true);
  document.addEventListener("visitorConsentCollected", onConsentCollected);
  window.addEventListener("pageshow", function () {
    syncToCart(false);
  });
})();
